(function() {
    'use strict';

    const scriptUrl = 'https://cdn.cubie.com.au/script/analytics.js';

    // Check if script is already loaded to avoid duplicates
    if (document.querySelector(`script[src="${scriptUrl}"]`)) {
        return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true; // Loads in background without blocking page render
    script.src = scriptUrl;

    // Optional: Log when the script has successfully loaded from your CDN
    script.onload = function() {
        console.log('[Cubie] Main analytics script loaded successfully.');
    };

    // Optional: Handle errors if your CDN is down
    script.onerror = function() {
        console.error('[Cubie] Failed to load the main analytics script.');
    };

    // Append to Head or Body
    (document.head || document.documentElement).appendChild(script);
})();